var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#E7F2F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 22.6663H10.6667C10.2985 22.6663 10 22.3679 10 21.9997V9.99967C10 9.63149 10.2985 9.33301 10.6667 9.33301H21.3333C21.7015 9.33301 22 9.63149 22 9.99967V21.9997C22 22.3679 21.7015 22.6663 21.3333 22.6663ZM20.6667 21.333V10.6663H11.3333V21.333H20.6667ZM13.3333 12.6663H18.6667V13.9997H13.3333V12.6663ZM13.3333 15.333H18.6667V16.6663H13.3333V15.333ZM13.3333 17.9997H18.6667V19.333H13.3333V17.9997Z",
    fill: "#0D8091"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotal);
export default __webpack_public_path__ + "static/media/total.fdd8d140859e853519a6324bdf682ca8.svg";
export { ForwardRef as ReactComponent };